import clsx from 'clsx';
import { isEmpty } from 'lodash-es';
import { useState } from 'react';
import { adPlaceholderJpg } from '../../../assets';
import type { SubCategory } from '../../../api';
import { useMenuStore } from '../../../stores';
import { SubCategoryLink } from '../SubCategoryLink';
import { ChildCategoryLink } from '../ChildCategoryLink';
import { BrandLink } from '../BrandLink';
import { SubCategoryAd } from '../SubCategoryAd';

export function MenuDesktopPanel() {
  const selectedSubCategory = useMenuStore.use.selectedSubCategory();
  const selectedChildCategory = useMenuStore.use.selectedChildCategory();
  const setSelectedChildCategory = useMenuStore.use.setSelectedChildCategory();

  const [isCheckBrand, setIsCheckBrand] = useState(false);

  const subCategoryChildren = selectedSubCategory?.subCategories ?? [];
  const childCategoryChildren = selectedChildCategory?.subCategories ?? [];
  const brandIcons = selectedSubCategory?.otherAds?.brandIcons ?? [];

  const hasBrandIcons = brandIcons.length > 0;
  const hasChildCategoryChildren = childCategoryChildren.length > 0;
  const isFirstPanelVisible = subCategoryChildren.length > 0;
  const isSecondPanelVisible = hasChildCategoryChildren || hasBrandIcons;
  const isSubCategoryAdVisible = !isEmpty(selectedSubCategory?.categoryAds);
  const isBrandIconsVisible = isCheckBrand && !selectedChildCategory;

  return (
    <div
      className={clsx(
        'tlw-p-3 tlw-pt-0 tlw-grid tlw-gap-2 tlw-overflow-hidden',
        isSecondPanelVisible
          ? 'tlw-grid-cols-[2fr_3fr_5fr]'
          : isFirstPanelVisible
          ? 'tlw-grid-cols-[4.5fr_5.5fr]'
          : 'tlw-grid-cols-1'
      )}
    >
      {/* 中類選單 */}
      {isFirstPanelVisible && (
        <div className="tlw-bg-gray-300 tlw-rounded-xl tlw-overflow-hidden">
          <div className="tlw-scrollbar | tlw-h-full tlw-px-8 tlw-py-10 tlw-space-y-6 tlw-overflow-y-auto">
            <h2 className="tlw-txt-zh-head-2 tlw-text-txt-800">
              {selectedSubCategory?.title}
            </h2>

            <ul className="tlw-space-y-1">
              {subCategoryChildren.map((item) => {
                const hasChildren = Boolean(item.subCategories?.length);
                return (
                  <li key={`${item.categoryId}_${item.title}`}>
                    <SubCategoryLink
                      category={item}
                      showArrow={hasChildren}
                      isActive={
                        item.title === selectedChildCategory?.title &&
                        item.categoryId === selectedChildCategory?.categoryId
                      }
                      onClick={(e) => {
                        hasChildren && e.preventDefault();
                        setSelectedChildCategory(item);
                        setIsCheckBrand(false);
                      }}
                    />
                  </li>
                );
              })}

              {hasBrandIcons && (
                <li key="brandIcons">
                  <SubCategoryLink
                    className="tlw-cursor-pointer"
                    category={{ title: '品牌推薦' } as unknown as SubCategory}
                    showArrow={Boolean(hasBrandIcons)}
                    isActive={isBrandIconsVisible}
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedChildCategory(null);
                      setIsCheckBrand(true);
                    }}
                  />
                </li>
              )}
            </ul>
          </div>
        </div>
      )}

      {/* 小類選單 */}
      {isSecondPanelVisible && (
        <div className="tlw-bg-gray-100 tlw-rounded-xl tlw-overflow-hidden">
          <div className="tlw-scrollbar | tlw-h-full tlw-px-10 tlw-py-15 tlw-space-y-4 tlw-overflow-y-auto">
            <h3 className="tlw-txt-zh-head-4 tlw-text-txt-800">
              {selectedChildCategory?.title ?? (hasBrandIcons && '品牌推薦')}
            </h3>

            {isBrandIconsVisible ? (
              <ul className="tlw-grid tlw-auto-rows-[68px] tlw-grid-cols-2 tlw-gap-x-6 tlw-gap-y-8 xl:tlw-grid-cols-3">
                {brandIcons.map((item, index) => (
                  <li key={`brandIcons_${index}`}>
                    <BrandLink categoryAd={item} />
                  </li>
                ))}
              </ul>
            ) : (
              <ul className="tlw-px-1 tlw-space-y-1">
                {childCategoryChildren.map((item) => (
                  <li key={`${item.categoryId}_${item.title}`}>
                    <ChildCategoryLink category={item} />
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}

      {/* 大類廣告 */}
      {isSubCategoryAdVisible && <SubCategoryAd />}

      {/* 缺省占位 */}
      <div
        className={clsx(
          'tlw-grid tlw-place-items-center tlw-bg-cover tlw-bg-no-repeat tlw-bg-center tlw-rounded-xl tlw-overflow-hidden',
          {
            'tlw-hidden':
              isFirstPanelVisible ||
              isSecondPanelVisible ||
              isSubCategoryAdVisible,
          }
        )}
        style={{ backgroundImage: `url(${adPlaceholderJpg})` }}
      >
        <p className="tlw-txt-zh-head-6 tlw-text-txt-500">自組樂趣、自造美好</p>
      </div>
    </div>
  );
}
